import { Component, EventEmitter, Input, Output, ViewChild, computed, inject } from '@angular/core';
import { ThemeService } from '../services/theme';
import { InfoModal } from '../info-modal/info-modal';
import { makeEvent } from '../analytics/builder';
import { SnowplowService } from '../services/snowplow';

// Opens the general "Umfang der Analysen" InfoModal (V2's app-nav-bar one), or with
// [opensPage] only emits pageClicked for the per-tab info page — see v3-info-page/CLAUDE.md.
@Component({
  selector: 'app-v3-info-button',
  templateUrl: './v3-info-button.html',
  styleUrl: './v3-info-button.scss',
  standalone: true,
  imports: [InfoModal],
})
export class V3InfoButton {
  @Input() size = 18;
  @Input() opensPage = false;
  @Output() pageClicked = new EventEmitter<void>();

  private readonly themeService = inject(ThemeService);
  private readonly snowplow = inject(SnowplowService);

  readonly iconSrc = computed(() =>
    this.themeService.isLight() ? '/info-light.svg' : '/info.svg',
  );

  @ViewChild('modal') modal?: InfoModal;

  onInfoClick() {
    if (this.opensPage) {
      this.pageClicked.emit();
    } else {
      this.modal?.open();
    }

    this.snowplow.track(
      makeEvent('element_clicked', {
        element_title: 'info_icon_asset_analysis',
        feature_name: 'icon',
      }),
    );
  }

  onInfoClose() {
    this.modal?.close();
  }
}
